window.addEventListener('load', function () {
  const gallery = document.querySelector('#shopify-section-template--17408483754171__gallery_fjBkpB');
  const productBlocks = document.querySelectorAll('#shopify-section-template--17408483754171__main .product-grid .product-block');
  
  if (!gallery) {
    return;
  }

  if (productBlocks.length < 4) {
    return;
  }
  const fourthBlock = productBlocks[3];
  const productGrid = fourthBlock.parentNode; 
  
  if (gallery && gallery.parentElement) {
    gallery.parentElement.removeChild(gallery);
  }
  
  let wrapper = document.querySelector('#gallery-wrapper-fullwidth');
  if (!wrapper) {
    wrapper = document.createElement('div');
    wrapper.id = 'gallery-wrapper-fullwidth';

    if (fourthBlock.nextSibling) {
      productGrid.insertBefore(wrapper, fourthBlock.nextSibling);
    } else {
      productGrid.appendChild(wrapper);
    }
  }
  wrapper.appendChild(gallery);
  gallery.style.display = 'block';
});

window.addEventListener('load', () => {
  const thumbnailColorEl = document.querySelector('#thumbnail-color');
  if (thumbnailColorEl && thumbnailColorEl.dataset.color) {
    const color = thumbnailColorEl.dataset.color;
    const productBlocks = document.querySelectorAll('.product-block__image');
    productBlocks.forEach(el => {
      el.style.backgroundColor = color;
    });
  }
});

window.addEventListener("DOMContentLoaded", () => {
  if (document.body.matches('.template-page.template-suffix-contact')) {
    document.querySelectorAll('.template-page.template-suffix-contact .section-custom-content .flexible-layout > .column > div .btn.btn--primary').forEach((el) => {
      if (el.textContent.trim() === 'NOT DISPLAY') {
        el.setAttribute('data-label', 'NOT DISPLAY');
      }
    });
  }
});